<xea-popover-base
  [popoverText]="params.value"
  [popoverParentNode]="popoverParentNode"
  [params]="params"
>
  <span>{{ params.value }}</span>
</xea-popover-base>
